import React from "react";

import { Container, ToastContainer } from "@catchoftheday/cg-components";
import { theme } from "@catchoftheday/theme";
import { HEADER_TOAST_CONTAINER_ID } from "@catchoftheday/toast";

export const HeaderToastContainer = () => (
  <Container position="relative" maxWidth={theme.maxWidths.default}>
    <ToastContainer
      containerId={HEADER_TOAST_CONTAINER_ID}
      containerStyles={{
        position: "absolute",
        right: "15px",
        transform: "none",
        left: "auto",
        width: "320px",
      }}
      toastStyles={{
        fontFamily: theme.fonts.catch,
      }}
    />
  </Container>
);
